import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { UiDateInputComponent } from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-date-input-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiDateInputComponent, AppExampleSectionComponent],
  templateUrl: './date-input-doc.component.html',
  styleUrl: './date-input-doc.component.scss',
})
export class DateInputDocComponent {
  protected readonly dateValue = signal('');
  protected readonly datetimeValue = signal('');
  protected readonly timeValue = signal('');
  protected readonly isInvalid = signal(false);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }
}
